import { FC } from 'react';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { EngagementDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { useReactTable, getCoreRowModel } from '@tanstack/react-table';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { useReminderErrorsTableColumns } from '../../hooks/table-columns/reminder-errors-table-columns.hook';
import { Box } from '@mui/material';

export type ReminderColumnName =
	| 'engagementId'
	| 'engagementTitle'
	| 'columnName'
	| 'columnValue'
	| 'message'
	| 'actions';

type ReminderConfirmTableProps = TableListQueryResponse<{ engagementId: string; message: string }> & {
	reminderConfirmColumnsList: ReminderColumnName[];
};

export const ReminderConfirmTable: FC<ReminderConfirmTableProps> = (props) => {
	const {
		data,
		sorting,
		onSortingChange,
		loading,
		hasMore,
		fetchMore,
		scrollRef,

		reminderConfirmColumnsList,
	} = props;

	const [t] = useTranslation();

	const columns = useReminderErrorsTableColumns(reminderConfirmColumnsList);

	const table = useReactTable<any>({
		data,
		columns,
		state: {
			sorting,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			maxHeight={200}
			emptyListComponent={<CoreTableEmptyBody description={t('engagements.no-engagements')} />}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={[]}
			border
			shadow
		/>
	);
};
